// The two portal roles (README decision 321).
export enum UserRole {
    Admin    = 'admin',
    Operator = 'operator',
}
